import {Component, effect, inject, Input} from '@angular/core';
import {ChatMessage, POLARIS_NAME, UserMessageResponse} from '../../copilot.model';
import {CommonModule} from '@angular/common';
import {ProgressBarComponent} from '../progress-bar/progress-bar.component';
import {CopilotService} from '../../../../services/copilot.service';
import {ButtonComponent} from "../../../../shared/components/button/button.component";
import {MarkdownComponent} from '../../../../shared/components/markdown/markdown.component';
import {CopilotCreativesMessageComponent} from './copilot-creatives-message/copilot-creatives-message.component';
import {CopilotGraphsMessageComponent} from './copilot-graphs-message/copilot-graphs-message.component';
import {CopilotFollowupQuestionsMessageComponent} from './copilot-followup-questions-message/copilot-followup-questions-message.component';
import {CopilotInsightsMessageComponent} from './copilot-insights-message/copilot-insights-message.component';
import { TrimSurroundingQuotesPipe } from "../../../../pipes/trim-surrounding-quotes.pipe";
import { ResponseActionButtonsComponent } from '../response-action-buttons/response-action-buttons.component';
import {PolarisIconComponent} from '../polaris-icon/polaris-icon.component';

@Component({
  selector: 'app-copilot-message',
  imports: [
    CommonModule,
    ProgressBarComponent,
    ButtonComponent,
    MarkdownComponent,
    CopilotCreativesMessageComponent,
    CopilotGraphsMessageComponent,
    CopilotFollowupQuestionsMessageComponent,
    CopilotInsightsMessageComponent,
    TrimSurroundingQuotesPipe,
    ResponseActionButtonsComponent,
    PolarisIconComponent
  ],
  templateUrl: './copilot-message.component.html',
  styleUrl: './copilot-message.component.scss'
})
export class CopilotMessageComponent {

  @Input() message!: ChatMessage;
  @Input() sendMessage!: string | null;
  public shouldDisplayMessage = false;
  public shouldDisplayThink = false;
  public shouldDisplayRetryButton = false;
  public isCopySucceeded = false;
  copilotService = inject(CopilotService);
  public polarisName = POLARIS_NAME;
  constructor() {
    setTimeout(() => {
      this.shouldDisplayMessage = true;
      this.shouldDisplayThink = true;
    },500)
    setTimeout(() => {
      this.shouldDisplayThink = false;
    },1500)
    effect(() => {
      const id = this.copilotService.lastAssistantMessageId();
      if (id) {
        this.shouldDisplayRetryButton = this.message.id === id;
      }
    });
  }

  public tryAgain() {
    this.copilotService.retryUserMessage(this.sendMessage as string, this.message.interactionId as string);
  }

  public async onCopy(): Promise<void> {
    const success = await this.copyTextToClipboard();
    if (success) {
      this.isCopySucceeded = true;
      setTimeout(() => {
        this.isCopySucceeded = false;
      }, 1000);
    }
  }

  private async copyTextToClipboard(): Promise<boolean> {
    if (!this.message.content) {
      return false;
    }
    let text = this.message.content + `${this.message.insights ? '\nInsights:\n' + this.message.insights : ''}`;
    // Remove markdown formatting
    text = text
      .replace(/\*\*/g, '')  // Remove bold markers
      .replace(/\*/g, '')    // Remove italic markers
      .replace(/\_\_/g, '')  // Remove bold underscores
      .replace(/\_/g, '')    // Remove italic underscores
      .replace(/\~/g, '');   // Remove strikethrough

    await navigator.clipboard.writeText(text);
    return true;
  }

  public onShare(): void {
   // TODO: implement share action when will have a design
  }

  public onGoodResponse(): void {
    this.message.userResponse = UserMessageResponse.POSITIVE;
    this.copilotService.saveChatsToStorage();
  }

  public onBadResponse(): void {
    this.message.userResponse = UserMessageResponse.NEGATIVE;
    this.copilotService.saveChatsToStorage();
  }

  public onRetry(): void {
    this.copilotService.retryUserMessage(this.sendMessage as string, this.message.interactionId as string);
  }
}
